import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import map from 'lodash/map';

import styles from './Category.css';
import CategoryItem from './CategoryItem.js';

const Category = ({
  categoryData,
  showHeader = false,
  increment,
  decrement,
  selectListItem,
  highlightListItem = noop,
  selectedListItem,
  showDescriptions = false,
  showSmallCountControls,
  handleSuccess = noop,
  focusSearchInput = noop,
  ...other
}) => {
  const { name, items } = categoryData;

  const header = <header className={styles.categoryHeader}>{name}</header>;

  const categoryItemsKeys = () => {
    return map(items, (item, itemIndex) => {
      return  `${name}${item.id || itemIndex}`;
    });
  };
  const navigateUp = () => {
    const currentItemIndex = categoryItemsKeys().indexOf(selectedListItem);
    const nextItemIndex = currentItemIndex - 1 > -1 ? currentItemIndex -1: currentItemIndex;
    const nextItem = items[nextItemIndex];
    const nextItemKey = `${name}${nextItem.id || nextItemIndex}`;
    if (nextItemIndex === currentItemIndex){
      highlightListItem('', -1);
      focusSearchInput();
    }
    else{
      highlightListItem(nextItemKey, nextItemIndex);
    }
  };
  const navigateDown = () => {
    const currentItemIndex = categoryItemsKeys().indexOf(selectedListItem);
    const nextItemIndex = currentItemIndex + 1 < items.length ? currentItemIndex + 1: currentItemIndex;
    const nextItem = items[nextItemIndex];
    const nextItemKey = `${name}${nextItem.id || nextItemIndex}`;
    highlightListItem(nextItemKey, nextItemIndex);
  };
  const handleSuccessOnEnter = () => {
    const currentItemIndex = categoryItemsKeys().indexOf(selectedListItem);
    const item = items[currentItemIndex];
    selectListItem(selectedListItem, item, handleSuccess);
  };

  const categoryItems = map(items, (item, itemIndex) => {
    // TODO: avoid using index as part React key definition (anti-pattern)
    const itemKey = `${name}${item.id || itemIndex}`;
    return (
      <li key={itemKey}>
        <CategoryItem
          key={itemKey}
          onClick={() => selectListItem(itemKey, item)}
          showDescription={showDescriptions}
          showSmallCountControls={showSmallCountControls}
          increment={() => increment(item)}
          decrement={() => decrement(item)}
          item={item}
          selected={selectedListItem === itemKey}
          navigateUp={navigateUp}
          navigateDown={navigateDown}
          onEnterPress={handleSuccessOnEnter}
        />
      </li>
    );
  });

  return (
    <section {...other} className={styles.categoryWrapper}>
      {showHeader ? header : null}

      <ul className={styles.category}>
        {categoryItems}
      </ul>
    </section>
  );
};

Category.propTypes = {
  categoryData: PropTypes.object.isRequired,
  decrement: PropTypes.func,
  increment: PropTypes.func,
  handleSuccess: PropTypes.func,
  selectedListItem: PropTypes.string,
  selectListItem: PropTypes.func,
  highlightListItem: PropTypes.func,
  focusSearchInput: PropTypes.func,
  showDescriptions: PropTypes.bool,
  showSmallCountControls: PropTypes.bool,
  showHeader: PropTypes.bool
};

export default Category;
